import { summitDistributionSeasonStart } from '@lc/const/summit';
import { normalSeasonalTurn } from '@lc/const/turnTypes';

import { GameState } from './types';

export function createGameState(
	game_id_server: number,
	initPlayerTableOrder: number[],
	decks: number[][],
	singlePlayer: boolean = false,
	isTutorial: boolean = false
): GameState {
	const numPlayers = initPlayerTableOrder.length;

	const tutorialStep = isTutorial ? 0 : 1000;

	return {
		initPlayerTableOrder: [...initPlayerTableOrder],
		currentTurnTypePlayerTableOrder: [...initPlayerTableOrder],
		turnOrder: [...initPlayerTableOrder],
		numPlayers,
		activePlayerId: -1,
		monthTracker: 0,
		seasonTracker: 0,
		carbonReservoir: 25,
		turnType: normalSeasonalTurn,
		singlePlayer,
		isTutorial,
		tutorialStep,
		game_id_server,
		gameStatus: 0,
		summitCardDistribution: summitDistributionSeasonStart,
		weightIndex: 0,
		worldEnergy: { red: 0, green: 0, blue: 0, yellow: 0, carbon: 0 },
		DeckSS: decks[0],
		DeckFW: decks[1],
		DeckNews: decks[2],
		DeckSummit: decks[3],
		discardPile: [],
		seasonalNewsCards: [],
		playerStateArray: [],
		triggers: [],
		decisionPlayerId: -1,
		decisionCardId: -1,
		decisionChoiceArr: [],
		decisionSourceArr: [],
		decisionTargetArr: [],
		isSummit: false,
		isSummitWinter: false,
		summitDraftPlayerIds: [],
		summitDraftCardIds: [],
		summitDraftCardIdArrForDepth: [],
		summitDraftCardIdForPlayer: [],
		summitWinners: [],
	};
}
